import styled from 'styled-components'

const getSeparatorMargin = (props, breakpoint = 'mobile') => {
  switch (breakpoint) {
    case 'portrait':
      return props.theme.shell.footer.tenants.separatorMargin?.portrait
    case 'landscape':
      return props.theme.shell.footer.tenants.separatorMargin?.landscape || '36px 0'
    case 'mobile':
    default:
      return props.theme.shell.footer.tenants.separatorMargin?.mobile || '24px 0'
  }
}

const FooterView = styled.footer`
  display: flex;
  flex-flow: column;
  align-items: center;
  background-color: ${props => props.theme.shell.footer.tenants.backgroundColor};
  border-top: ${props => props.theme.shell.footer.tenants.borderTop || 'none'};

  hr {
    width: 100%;
    margin: ${props => getSeparatorMargin(props)};
    height: 1px;
    border: none;

    @media screen and (min-width: ${props => props.theme.breakpoints.portrait}px) {
      margin: ${props => getSeparatorMargin(props, 'portrait')};
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.landscape}px) {
      margin: ${props => getSeparatorMargin(props, 'landscape')};
    }
  }
`
export default FooterView
